import { useFeatureFlag } from '@moda/portal-stanchions';
import { isNavLinksFlagValue, NavLinksFlagValue } from '../../lib/isNavLinksFlagValue';

export const useHomePageMiniNavLinks = () =>
  useFeatureFlag<NavLinksFlagValue>('homepage-mobile-mini-nav', [
    { default: null },
    { getFromTreatment: treatment => (isNavLinksFlagValue(treatment) ? treatment : null) }
  ]);
